import Vue from 'vue'
import dayjs from 'dayjs'

const formatHour = value => {
  if (value) {
    return dayjs(value).format('YYYY-MM-DD HH:mm')
  } else {
    return '-'
  }
}

const formatHourToSlash = value => {
  if (value) {
    return dayjs(value).format('YYYY/MM/DD HH:mm')
  } else {
    return '-'
  }
}

const ifEmpty = value => {
  return value || '--'
}

let oneDecimal = value => {
  return parseFloat(value).toFixed(1)
}

Vue.filter('formatHour', formatHour)
Vue.filter('formatHourToSlash', formatHourToSlash)
Vue.filter('ifEmpty', ifEmpty)
Vue.filter('oneDecimal', oneDecimal)



// WEBPACK FOOTER //
// ./src/util/vue-filters.js